namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumMandatoryMFg {
        MandatoryMemberFgNo = 0,
        MandatoryMemberFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumMandatoryMFg, 'GeniuzPOS.InitialData.PsPosStationEumMandatoryMFg');
}
